import { createSlice } from '@reduxjs/toolkit';
import { getDataWeatherCurrent, getDataWeatherData } from '../dataWeather/thunk';

export const initialState = {
  itemDataWeather: null, 
  itemDataWeatherByType: {}, // Almacena los datos separados por tipo
  isLoadingByType: {}, // Almacena el estado de carga por tipo
  isDataWeatherSuccess: false,
  isLoadingList: false,
  isAdding: false,
  isAdded: false,
  isAddError: false,
  isUpdating: false,
  isUpdated: false,
  isUpdateError: false,
  isDeleting: false,
  isDeleted: false,
  isDeleteError: false,
  requireCloseModal: false,
};

const DataWeatherSlice = createSlice({
  name: 'DataWeather',
  initialState,
  reducers: {
    setRequireCloseModal(state, action) {
      state.requireCloseModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDataWeatherData.pending, (state, action) => {
      const { type } = action.meta.arg; // El `type` se pasa como argumento en el thunk
      state.isLoadingByType[type] = true;
      state.isDataWeatherSuccess = false;
    });
    builder.addCase(getDataWeatherData.fulfilled, (state, action) => {
      const { type } = action.meta.arg; // El `type` se pasa como argumento en el thunk
      state.itemDataWeatherByType[type] = action.payload;
      state.isLoadingByType[type] = false;
      state.isDataWeatherSuccess = true;
    });
    builder.addCase(getDataWeatherData.rejected, (state, action) => {
      const { type } = action.meta.arg; // El `type` se pasa como argumento en el thunk
      state.isLoadingByType[type] = false;
      state.isDataWeatherSuccess = false;
      state.error = action.payload || null;
    });

    
    builder.addCase(getDataWeatherCurrent.pending, (state, action) => {
      state.isLoadingList = true;
      state.isDataWeatherSuccess = false;
    });
    builder.addCase(getDataWeatherCurrent.fulfilled, (state, action) => {
      state.itemDataWeather = action.payload;
      state.isLoadingList = false;
      state.isDataWeatherSuccess = true;
    });
    builder.addCase(getDataWeatherCurrent.rejected, (state, action) => {
      state.isLoadingList = false;
      state.isDataWeatherSuccess = false;
      state.error = action.payload || null;
    });
  },
});

export const { setRequireCloseModal } = DataWeatherSlice.actions;

export default DataWeatherSlice.reducer;
